import React, { Fragment } from "react";

function LoadingSpinner({ message, description, className = "" }) {

    return (
        <Fragment>
            <div className={`dashboard-container loading-spinner-container ${className}`.trim()}>
                <div className="loading-spinner">
                </div>
                {message && (
                    <div className="loading-spinner-copy">
                        <p className="loading-spinner-message">{message}</p>
                        {description && <p className="loading-spinner-description">{description}</p>}
                    </div>
                )}
            </div>
        </Fragment>
    )
}
export default LoadingSpinner;
